/**
 *  All api related to system setting
 */

import _ from 'lodash'
import { CancelToken } from 'axios'

import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'
import config from '../../config'

export function fetchTenants(params = {}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchTenants',
    () => source.cancel('fetchTenants: Operation cancelled by user')
  )

  const apiOptions = {
    endpoint: 'tenants',
    method: 'get',
    params,
    cancelToken: source.token,
  }

  return OmnitechApi
    .request(apiOptions)
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      tenants: data.tenants,
      cacheChecksum: _.get(cacheChecksum, 'tenantsValue'),
    }))
}

export function fetchTenant(options = {}) {
  const {
    code,
    ...params
  } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchTenant',
    () => source.cancel('fetchTenants: Operation cancelled by user')
  )

  const apiOptions = {
    endpoint: `tenants/by_code/${code}`,
    method: 'get',
    params,
    cancelToken: source.token,
  }

  return OmnitechApi
    .request(apiOptions)
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      tenant: data.tenant,
      cacheChecksum: _.get(cacheChecksum, 'tenantsValue'),
    }))
}
